import { render } from "./AlipayDMF.vue?vue&type=template&id=977da544"
import script from "./AlipayDMF.vue?vue&type=script&lang=js"
export * from "./AlipayDMF.vue?vue&type=script&lang=js"

import "./AlipayDMF.vue?vue&type=style&index=0&id=977da544&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__